import i18n from "../plugins/i18n";
import RouteTranslations from "@/locales/routerTranslations";
import store from "@/store";
import { Tag } from "@/models/tag";
import moment, { Moment } from "moment";
import "moment/locale/it";

export default {
  getDay(date: any) {
    const momentObj = moment(date, moment.ISO_8601);
    return momentObj.isoWeekday();
  },
  onSameDay(a: Moment, b: Moment): boolean {
    return a.year() === b.year() && a.month() === b.month() && a.date() === b.date();
  },
  dateFormatter(date: any, formatType?: string): string {
    moment.locale(i18n.locale);
    const momentObj = moment(date, moment.ISO_8601);
    if (formatType === "hours") {
      return `${momentObj.isValid() ? momentObj.format("DD MMMM YYYY - HH:mm") : ""
        }`;
    }
    if (formatType === "d-m") {
      return `${momentObj.isValid() ? momentObj.format("DD/MM") : ""}`;
    }
    if (formatType === "yyyy-m-d") {
      return `${momentObj.isValid() ? momentObj.format("YYYY-MM-DD") : ""}`;
    }
    return `${momentObj.isValid() ? momentObj.format("ddd DD MMM YYYY") : ""}`;
  },
  handleRoute(path: string, query?: { [k: string]: any }): any {
    const translations: any = RouteTranslations;
    let toRoute: string = "";
    if (path) {
      toRoute = translations[i18n.locale][path].link;
    }
    if (query) {
      return {
        path: toRoute,
        query
      }
    }
    return toRoute;
  },
  buildFilteredRequest(array: any[]) {
    let queryString = "";
    const selects = array.filter(item => item.type === "select");
    selects.map(item => {
      if (item.selectedVal && item.listType && item.queryParam) {
        if (queryString !== "") queryString += "&";
        queryString += `${item.queryParam}=${item.selectedVal.id}`;
      }
      return "";
    });
    const selectsArrays = array.filter(item => item.type === "selectArray");
    selectsArrays.map(item => {
      if (item.selectedVal && item.listType && item.queryParam) {
        if (!Array.isArray(item.selectedVal)) {
          item.selectedVal = [item.selectedVal];
        }
        item.selectedVal.forEach((element: any) => {
          if (queryString.includes(item.queryParam)) {
            queryString += `,${element.id}`;
          } else {
            queryString !== ""
              ? (queryString += `&${item.queryParam}=${element.id}`)
              : (queryString += `${item.queryParam}=${element.id}`);
          }
        });
      }
      return "";
    });
    const inputsNum = array.filter(item => item.type === "inputNumber");
    inputsNum.map(item => {
      if (item.value && item.inputType && item.queryParam) {
        if (item.value.length > item.charLimit) {
          if (queryString !== "") queryString += "&";
          queryString += `${item.queryParam}=${item.value}`;
        }
      }
      return "";
    });
    const inputs = array.filter(item => item.type === "input");
    inputs.map(item => {
      if (item.value && item.inputType && item.queryParam) {
        if (item.value.length > item.charLimit) {
          if (queryString !== "") queryString += "&";
          queryString += `${item.queryParam}=${item.value}`;
        }
      }
      return "";
    });
    const inputsDate = array.filter(item => item.type === "inputDate");
    inputsDate.map(item => {
      if (item.selectedVal && item.listType && item.queryParam) {
        if (queryString !== "") queryString += "&";
        if (!Array.isArray(item.selectedVal)) {
          queryString += `${item.queryParam}=${item.value}`;
        } else {
          if (item.selectedVal) {
            if (item.selectedVal.length > 0) {
              queryString += `${item.queryParam[0]}=${item.selectedVal[0]}`;
            }
            if (item.selectedVal.length > 1) {
              queryString += `&${item.queryParam[1]}=${item.selectedVal[1]}+23:59:00`;
            }
          }
        }
      }
      return "";
    });
    const inputsCheckbox = array.filter(item => item.type === "checkbox");
    inputsCheckbox.map(item => {
      if (item.value && item.queryParam) {
        if (queryString !== "") queryString += "&";
        queryString += `${item.queryParam}=${item.value}`;
      }
      return "";
    });
    return queryString;
  },
  paginationBuildRequest(rowsPerPage?: number, page?: number) {
    // console.log("rowsPerPage", rowsPerPage);
    // console.log("page", page);
    let quesryString = "";
    if (page) {
      quesryString += `&page=${page}`;
    } else {
      quesryString += `&page=1`;
    }
    if (rowsPerPage) {
      quesryString += `&per_page=${rowsPerPage}`;
    } else {
      quesryString += `&per_page=10`;
    }
    return quesryString;
  },
  paginationSortBuildRequest(
    typesArray: any,
    sortBy?: string,
    sortType?: string
  ) {
    // console.log("sortBy", sortBy);
    // console.log("sortType", sortType);
    let quesryString = "";
    if (sortBy) {
      quesryString += `&sort=${this.sortElementArray(typesArray, sortBy).string
        }`;
      if (sortType) {
        quesryString += `&sort_type=${sortType}`;
      }
    }
    return quesryString;
  },
  sortElementArray(typesArray: any, element: any) {
    return typesArray.find((el: any) => element === el.id);
  },
  buildTagsArray(tagsArray: any, categoryCode: any) {
    const tags: any[] = [];
    store.state.app.tagsList.map((category: any) => {
      if (category.code === categoryCode) {
        tagsArray.map((tag: any) => {
          if (tag.category && tag.category.id === category.id) {
            tags.push(new Tag().deserialize(tag));
          }
        });
      }
    });
    return tags;
  },
  buildTagsArrayV2(tagsArray: any, categoryCode: any) {
    const tags: any[] = [];
    store.state.app.tagsList.map((category: any) => {
      if (category.code === categoryCode) {
        tagsArray.map((tag: any) => {
          if (tag.category && tag.category.code === category.code) {
            tags.push(new Tag().deserializeV2(tag));
          }
        });
      }
    });
    return tags;
  },
  buildMoodTags() {
    let moods: any[] = [];
    store.state.app.tagsList.map((category: any) => {
      if (category.code === "mood") {
        moods = category.tags;
      }
    });
    return moods;
  },
  buildIconTagsArray(tagsArray: any, categoryCode: any) {
    const tags: any[] = [];
    if (store.state.app.tagsList) {
      store.state.app.tagsList.map((category: any) => {
        if (category.tags) {
          category.tags.map((tagStored: any) => {
            tagsArray.map((tag: any) => {
              if (tag.id === tagStored.id && category.code === categoryCode) {
                tags.push(tagStored);
              }
            });
          });
        }
      });
    }
    return tags;
  },
  buildCustomTagsList(tagsArray: any, categoryName: any) {
    const tags: any[] = [];
    if (store.state.app.tagsList) {
      store.state.app.tagsList.map((category: any) => {
        if (category.tags) {
          category.tags.map((tagStored: any) => {
            tagsArray.map((tag: any) => {
              if (tag.id === tagStored.id && categoryName === category.code) {
                tags.push(tagStored);
              }
            });
          });
        }
      });
    }
    return tags;
  },
  isEmpty(obj: any) {
    for (let key in obj) {
      if (obj.hasOwnProperty(key)) return false;
    }
    return true;
  },
  imageUrlStringManager(parameters: string, imageUrl: string) {
    // let tempUrl = imageUrl.split("/");
    // tempUrl.splice(6, 1);
    // tempUrl.splice(6, 0, parameters);
    // tempUrl.join("/");
    // return tempUrl.join("/");
    return imageUrl.replace("upload/", `upload/${parameters}/`);
  },
  provincesArray() {
    return [
      "AG",
      "AL",
      "AN",
      "AO",
      "AQ",
      "AR",
      "AP",
      "AT",
      "AV",
      "BA",
      "BT",
      "BL",
      "BN",
      "BG",
      "BI",
      "BO",
      "BZ",
      "BS",
      "BR",
      "CA",
      "CL",
      "CB",
      "CI",
      "CE",
      "CT",
      "CZ",
      "CH",
      "CO",
      "CS",
      "CR",
      "KR",
      "CN",
      "EN",
      "FM",
      "FE",
      "FI",
      "FG",
      "FC",
      "FR",
      "GE",
      "GO",
      "GR",
      "IM",
      "IS",
      "SP",
      "LT",
      "LE",
      "LC",
      "LI",
      "LO",
      "LU",
      "MC",
      "MN",
      "MS",
      "MT",
      "VS",
      "ME",
      "MI",
      "MO",
      "MB",
      "NA",
      "NO",
      "NU",
      "OG",
      "OT",
      "OR",
      "PD",
      "PA",
      "PR",
      "PV",
      "PG",
      "PU",
      "PE",
      "PC",
      "PI",
      "PT",
      "PN",
      "PZ",
      "PO",
      "RG",
      "RA",
      "RC",
      "RE",
      "RI",
      "RN",
      "RM",
      "RO",
      "SA",
      "SS",
      "SV",
      "SI",
      "SR",
      "SO",
      "TA",
      "TE",
      "TR",
      "TO",
      "TP",
      "TN",
      "TV",
      "TS",
      "UD",
      "VA",
      "VE",
      "VB",
      "VC",
      "VR",
      "VV",
      "VI",
      "VT"
    ];
  },

  getLocation(): Promise<Position> {
    return new Promise((resolve, reject) => {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(resolve, reject);
      } else {
        reject("Not supported")
      }
    });
  }
};
